import React, {Component} from 'react';
import { withRouter } from "react-router-dom";





class ShipCentral extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Ship Central </h2>

                <br/>
               

                <h6> Overview: </h6>
                
                <p className='text-primary'>When shipping items are shipped back to guests, it can become difficult to track each package, shipping method, address, etc. 
                 The Ship Central screens helps to bring transparency and insight into all the shipped packages. 

                  </p>
                    <p className='text-info'>SEARCH: Enter search criteria to locate shipping records by name and address.   The search screen works instantly when typing and will try to match all the
                    data across the columns. For example if you wanted to search by last name Smith, simply typed Smith into the search field and all items that were shipped to anyone with the last name Smith will be displayed. 
                    Another example would be to locate a shipment with the amount of $25. Just type '25' in the search box and all shipments in the amount of $25 will only be displayed.
                    </p>
                 
                 
                <br/><br/><br/>
                <div className="text-center">
                    <img className='text-center' style={{width:"80%", height:"80%"}} src='./images/ShipCentral.png'  alt=''/> 
              
                 </div>

                <br/>

                <h5> Tracking Information </h5>
                <p className='text-primary'>
                Every shipping label created across any of the carriers will auto-generate an email to the customer or guest with their tracking ID. 
                That's same tracking ID can be located on Ship Central's table column called "tracking". If the guest has purchased a label this field will  display a link to the tracking information. 
                If the guest were to call and ask you where their shipment was and they had not received an email with the tracking information, you can click the link and display the carriers tracking 
                information on the package.
                
                
                </p>

              


                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(ShipCentral);
